import subscriptionEvents from "./events"
import eventHandlers from "./event-handlers"
import { EventRegister } from "@common/events/event-register"

export const registerEventListeners: EventRegister = (eventBus) => {
  eventBus.$on(subscriptionEvents.MEMBERSHIPS_ADDED, eventHandlers.handleMembershipsAddedEvent)
}
